import { render } from "./badge.vue?vue&type=template&id=15642e1a&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"

import "./badge.vue?vue&type=style&index=0&id=15642e1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15642e1a"]])

export default __exports__